import * as React from 'react';
import { Button } from '@cian/ui-kit/prev';
import * as styles from './SafeRentDescription.css';
import { trackSafeRentDescriptionShow, trackSafeRentDescriptionClick } from './tracking';
import { title, advsList } from './content';

export interface ISafeRentDescriptionProps {
  id: number;
  openModal(): void;
}

const advIcon = require('./assets/adv.svg') as string;

export const SafeRentDescription = ({ id, openModal }: ISafeRentDescriptionProps) => {
  /* istanbul ignore next */
  if (typeof window !== 'undefined') {
    trackSafeRentDescriptionShow(id);
  }

  return (
    <div id="safe-rent" className={styles['block']}>
      <div className={styles['title']}>
        {title.map((item: string) => (
          <div key={item}>{item}</div>
        ))}
      </div>

      <div className={styles['list']}>
        {advsList.map((item: string) => (
          <div key={item} className={styles['list-item']}>
            <img src={advIcon} className={styles['list-icon']} />
            {item}
          </div>
        ))}
      </div>

      <Button
        custom={{ type: 'primary', mediaType: 'mobile' }}
        styles={{ width: '170px' }}
        onClick={() => {
          trackSafeRentDescriptionClick(id);
          openModal();
        }}
      >
        <span className={styles['button-text']}>Заполнить анкету</span>
      </Button>
    </div>
  );
};
